<template>
  <div class="detail-view">
    <div class="detail-view--cover"></div>
    <div v-show="!isComparing" class="detail-view--img-wrap" 
      :style="{
        'transform': `translateX(${leftImageOperate.left}px) translateY(${leftImageOperate.top}px) scale(${leftImageOperate.scale}) rotate(${leftImageOperate.rotateAngle}deg)`,
      }"
      @mousedown="startDown($event, 0)"
      @mousemove="startMove($event, 0)"
      @mouseup="startEnd($event, 0)"
      @mouseout="startEnd($event, 0)"
      @touchstart="startDown($event, 0)"
      @touchmove="startMove($event, 0)"
      @touchend="startEnd($event, 0)"
      @touchcancel="startEnd($event, 0)"
    >
      <img 
        class="detail-view--img"
        :src="currentImg" alt="">
    </div>
    <div v-if="isComparing" class="detail-view--compare-wrap">
      <div :class="['detail-view--compare-img-wrap', selectedOperateImage === 0 ? 'selected' : '']" @click="selectOperateImage(0)">
        <div class="detail-view--compare-img-inner" 
          :style="{
            'transform': `translateX(${leftImageOperate.left}px) translateY(${leftImageOperate.top}px) scale(${leftImageOperate.scale}) rotate(${leftImageOperate.rotateAngle}deg)`,
          }"
          @mousedown="startDown($event, 0)"
          @mousemove="startMove($event, 0)"
          @mouseup="startEnd($event, 0)"
          @mouseout="startEnd($event, 0)"
          @touchstart="startDown($event, 0)"
          @touchmove="startMove($event, 0)"
          @touchend="startEnd($event, 0)"
          @touchcancel="startEnd($event, 0)"
        >
          <img 
            class="detail-view--compare-img" 
            :src="currentImg" alt="">
        </div>
      </div>
      <div :class="['detail-view--compare-img-wrap', selectedOperateImage === 1 ? 'selected' : '']" @click="selectOperateImage(1)">
        <div class="detail-view--compare-img-inner" 
          :style="{
            'transform': `translateX(${rightImageOperate.left}px) translateY(${rightImageOperate.top}px) scale(${rightImageOperate.scale}) rotate(${rightImageOperate.rotateAngle}deg)`,
          }"
          @mousedown="startDown($event, 1)"
          @mousemove="startMove($event, 1)"
          @mouseup="startEnd($event, 1)"
          @mouseout="startEnd($event, 1)"
          @touchstart="startDown($event, 1)"
          @touchmove="startMove($event, 1)"
          @touchend="startEnd($event, 1)"
          @touchcancel="startEnd($event, 1)"
        >
          <img 
            class="detail-view--compare-img" 
            :src="selectedCompareImg" alt="">
        </div>
        <div class="detail-view--compare-remove" @click="exitCompare($event)">
          <img class="detail-view--compare-remove-icon" 
            src="~@/assets/images/throwingPic/remove_ico.svg" alt="">
          <div class="detail-view--compare-remove-text">移除</div>
        </div>
      </div>
    </div>
    <div v-show="isShowCompareSelection" class="detail-view--select-compare">
      <div 
        class="detail-view--select-inner"
        :class="{
          'with-pages': showPageControl,
        }"
      >
        <div 
          v-for="item in compareImgList" 
          :key="item.url"
          class="detail-view--select-img-wrap" 
          :class="{
            selected: selectedCompareImg === item.url,
          }"
          @click="selectCompareImage(item.url)"
        >
          <div class="detail-view--select-img-inner">
            <img class="detail-view--select-img" 
              :src="item.url" alt="">
          </div>
          <img class="detail-view--select-icon"
            src="~@/assets/images/throwingPic/select_ico.svg" alt="">
        </div>
        <div class="detail-view--select-triangle"></div>
      </div>
    </div>
    <div class="detail-view--tools-wrap">
      <div class="detail-view--tools">
        <div class="detail-view--tool" @click="zoomIn">
          <img src="~@/assets/images/throwingPic/zoom-in.svg" class="detail-view--tool-icon" alt="">
          <div class="detail-view--tool-text">放大</div>
        </div>
        <div class="detail-view--tool" @click="zoomOut">
          <img src="~@/assets/images/throwingPic/zoom-out.svg" class="detail-view--tool-icon" alt="">
          <div class="detail-view--tool-text">缩小</div>
        </div>
        <div class="detail-view--tool" @click="rotate">
          <img src="~@/assets/images/throwingPic/rotate.svg" class="detail-view--tool-icon" alt="">
          <div class="detail-view--tool-text">旋转</div>
        </div>
        <div v-if="compareImgList.length > 0" :class="['detail-view--tool', isShowCompareSelection ? 'selected' : '']" @click="compareImage">
          <img src="~@/assets/images/throwingPic/vs_ico.svg" class="detail-view--tool-icon" alt="">
          <div class="detail-view--tool-text">对比</div>
        </div>
        <div class="detail-view--tool" @click="close">
          <img src="~@/assets/images/throwingPic/close2.svg" class="detail-view--tool-icon" alt="">
          <div class="detail-view--tool-text">关闭</div>
        </div>
      </div>
      <div v-show="showPageControl" class="page-tools">
        <div 
          class="page-tools-item page-tool-control page-tool-prev" 
          :class="{
            disabled: currentPage === 1,
          }"
          @click="prevPage"
        >
          <img src="~@/assets/images/left_ico.svg" class="control-img" alt="">
          <div class="text">上一张</div>
        </div>
        <div class="page-tools-item page-number">
          <div class="page">{{ currentPage }}/{{ imgList.length }}</div>
          <div class="text">页码</div>
        </div>
        <div 
          class="page-tools-item page-tool-control page-tool-next"
          :class="{
            disabled: currentPage === imgList.length,
          }"
          @click="nextPage">
          <img src="~@/assets/images/right_ico.svg" class="control-img" alt="">
          <div class="text">下一张</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [ 'currentIndex', 'imgList' ],
  data() {
    return {
      isComparing: false,
      isShowCompareSelection: false,
      selectedOperateImage: -1,
      leftImageOperate: {
        scale: 1,
        rotateAngle: 0,
        top: 0,
        left: 0,
      },
      rightImageOperate: {
        scale: 1,
        rotateAngle: 0,
        top: 0,
        left: 0,
      },
      isMove: false,
      disX: 0,
      disY: 0,
      lastRect: {
        top: 0,
        left: 0
      },
      lastScaleData: {
        scale: 1,
        distance: 1,
      },
      selectedCompareImg: null,
      currentPage: this.currentIndex + 1,
    };
  },
  computed: {
    currentImg() {
      return this.imgList[this.currentPage - 1].url;
    },

    compareImgList() {
      return this.imgList.filter((img, index) => {
        return index !== this.currentPage - 1;
      });
    },

    currentImgOperate() {
      return this.selectedOperateImage === 1 ? this.rightImageOperate : this.leftImageOperate;
    },

    showPageControl() {
      return this.imgList.length > 1 && !this.isComparing;
    },
  },
  methods: {
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.resetMainImgCompareConfig();
      }
    },

    nextPage() {
      if (this.currentPage < this.imgList.length) {
        this.currentPage++;
        this.resetMainImgCompareConfig();
      }
    },

    close() {
      this.$emit('close');
    },

    zoomIn() {
      this.zoom(1);
    },

    zoomOut() {
      this.zoom(-1);
    },

    zoom(multiple) {
      const scale = this.currentImgOperate.scale + 0.2 * multiple;
      this.setZoom(scale);
    },

    setZoom(scale) {
      this.currentImgOperate.scale = Math.max(scale, 0.2);
    },

    rotate() {
      this.currentImgOperate.left = 0;
      this.currentImgOperate.top = 0;
      this.currentImgOperate.rotateAngle -= 90;
    },

    compareImage() {
      this.isShowCompareSelection = !this.isShowCompareSelection;
    },

    selectCompareImage(url) {
      this.resetCompareConfig();
      this.isShowCompareSelection = false;
      this.isComparing = true;
      this.selectedCompareImg = url;
      this.selectedOperateImage = 1;
    },

    exitCompare(e) {
      e.stopPropagation();

      this.isComparing = false;
      this.$nextTick(() => {
        this.resetCompareConfig();
      });
    },

    resetMainImgCompareConfig() {
      this.leftImageOperate.top = 0;
      this.leftImageOperate.left = 0;
      this.leftImageOperate.scale = 1;
      this.leftImageOperate.rotateAngle = 0;
    },

    resetCompareConfig() {
      this.selectedOperateImage = -1;
      this.rightImageOperate.top = 0;
      this.rightImageOperate.left = 0;
      this.rightImageOperate.scale = 1;
      this.rightImageOperate.rotateAngle = 0;
      this.selectedCompareImg = null;
    },

    selectOperateImage(index) {
      this.selectedOperateImage = index;
    },

    getDistance(p1, p2) {
      const x = p2.pageX - p1.pageX;
      const y = p2.pageY - p1.pageY;

      return Math.sqrt(x * x + y * y);
    },

    startDown(e, i) {
      if (this.isComparing && i !== this.selectedOperateImage) return;

      this.isMove = true;

      if (e.touches && e.touches.length >= 2) {
        const distance = this.getDistance(e.touches[0], e.touches[1]);
        this.lastScaleData.distance = distance;
        this.lastScaleData.scale = this.currentImgOperate.scale;

        return;
      }

      let pageX;
      let pageY;

      if (e.touches) {
        pageX = e.touches[0].clientX;
        pageY = e.touches[0].clientY;
      } else {
        pageX = e.pageX;
        pageY = e.pageY;
      }

      this.disX = pageX;
      this.disY = pageY;

      this.lastRect.left = this.currentImgOperate.left;
      this.lastRect.top = this.currentImgOperate.top;
    },

    startMove(e, i) {
      e.preventDefault();
      if (this.isComparing && i !== this.selectedOperateImage) return;

      if (this.isMove) {
        if (e.touches && e.touches.length >= 2) {
          const step = 1;
          const scale = 
            this.getDistance(e.touches[0], e.touches[1]) / this.lastScaleData.distance / step * this.lastScaleData.scale;
          this.setZoom(scale);

          return;
        }

        let pageX;
        let pageY;

        if (e.touches) {
          pageX = e.touches[0].clientX;
          pageY = e.touches[0].clientY;
        } else {
          pageX = e.pageX;
          pageY = e.pageY;
        }

        const left = this.lastRect.left + pageX - this.disX;
        const top = this.lastRect.top + pageY - this.disY;

        this.currentImgOperate.left = left;
        this.currentImgOperate.top = top;
      }
    },

    startEnd(e, i) {
      // e.preventDefault();
      this.isMove = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-view {
  position: absolute;
  z-index: 3003;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;

  /deep/ img {
    -webkit-user-drag: none;
  }
}

.detail-view--cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .8);
}

.detail-view--tools-wrap {
  display: flex;
  position: absolute;
  z-index: 3;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
}

.detail-view--tools {
  width: 364px;
  height: 72px;
  display: flex;
  padding: 6px 12px;
  justify-content: space-between;
  border-radius: 4px;
  box-shadow: 0px 0px 4px 0px rgba(88, 109, 148, 0.5);
  background-color: rgba(0, 0, 0, .74);
}

.page-tools {
  margin-left: 20px;
  width: 211px;
  height: 72px;
  padding: 6px 12px 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  box-shadow: 0px 0px 4px 0px rgba(88, 109, 148, 0.5);
  background-color: rgba(0, 0, 0, .74);
  font-size: 16px;
  color: #FFFFFF;
  text-align: center;
}

.page-tool-prev {
  padding-right: 12px;
}

.page-tool-next {
  padding-left: 12px;
}

.page-tool-control {
  cursor: pointer;

  &.disabled {
    cursor: initial;
    opacity: .6;
  }
}

.page-tools-item {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}

.page-number {
  position: relative;
  flex: 1;

  .page {
    font-size: 18px;
    line-height: 30px;
    height: 30px;
  }
}

.detail-view--tool {
  width: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.detail-view--tool.selected,
.detail-view--tool:active {
  background-color: #037BFE;
}

.detail-view--tool-icon {
  display: block;
  width: 30px;
  height: 30px;
}

.detail-view--tool-text {
  font-size: 16px;
  color: #fff;
}

.detail-view--img-wrap {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding-top: 16px;
  padding-bottom: 112px;
  height: 100%;
}

.detail-view--img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.detail-view--compare-wrap {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 96px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-view--compare-img-wrap {
  position: relative;
  width: 50%;
  height: 100%;
  padding: 3px;
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  overflow: hidden;
}

.detail-view--compare-img-wrap::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 4;
  pointer-events: none;
}

.detail-view--compare-img-wrap.selected::before {
  border: 3px solid #037BFE;
}

.detail-view--compare-img-inner {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  height: 100%;
  overflow: hidden;
}

.detail-view--compare-img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.detail-view--select-compare {
  position: absolute;
  z-index: 5;
  left: calc(50% + 72px);
  bottom: 110px;
  width: 756px;
  height: 432px;
  transform: translateX(-50%);
}

.detail-view--select-inner {
  position: absolute;
  bottom: 0;
  display: flex;
  flex-wrap: wrap;
  max-width: 756px;
  border-radius: 4px;
  border: 10px solid rgba(0, 0, 0, 0.75);
  transform: translateX(calc(378px - 50%));
  background-color: rgba(255, 255, 255, .1);

  &.with-pages {
    transform: translateX(calc(260px - 50%));
  }
}

.detail-view--select-inner::before {
  content: '';
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  border: 1px solid rgba(255, 255, 255, 0.85);
  border-radius: 4px;
}

.detail-view--select-inner::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

.detail-view--select-img-wrap {
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  width: 184px;
  height: 205px;
  padding: 5px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.55);
}

.detail-view--select-img-wrap::before,
.detail-view--select-img-wrap::after {
  content: '';
  position: absolute;
  background-color: rgba(255, 255, 255, 0.2);
}

.detail-view--select-img-wrap::before {
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
}

.detail-view--select-img-wrap::after {
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
}

.detail-view--select-img-wrap.selected,
.detail-view--select-img-wrap.disabled {
  background-color: #000;
}

.detail-view--select-img-wrap.selected::before {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: initial;
  height: initial;
  border: 2px solid #037BFE;
  background: initial;
}

.detail-view--select-img-wrap.selected::after {
  display: none;
}

.detail-view--select-icon {
  display: none;
}

.detail-view--select-img-wrap.selected .detail-view--select-icon {
  display: block;
  position: absolute;
  right: 10px;
  bottom: 10px;
}

.detail-view--select-img-wrap.disabled {
  cursor: initial;
}

.detail-view--select-img-wrap.disabled .detail-view--select-img-inner {
  opacity: .6;
}

.detail-view--select-img-inner {
  display: flex;
  height: 100%;
  justify-content: center;
}

.detail-view--select-img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.detail-view--compare-remove {
  position: absolute;
  z-index: 3;
  left: 24px;
  bottom: 20px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(34, 34, 34, .49);
  border-radius: 14px;
  cursor: pointer;
}

.detail-view--compare-remove-icon {
  display: block;
  width: 16px;
  height: 16px;
  margin-right: 6px;
}

.detail-view--compare-remove-text {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
}

.detail-view--select-triangle {
  position: absolute;
  z-index: 4;
  left: 50%;
  bottom: -34px;
  width: 0;
  height: 0;
  border-width: 12px;
  border-color: rgba(255, 255, 255, 0.85) transparent transparent transparent;
  border-style: dashed solid dashed dashed;
  transform: translateX(-50%);
}

.detail-view--select-triangle::before {
  content: '';
  position: absolute;
  left: -12px;
  bottom: -10px;
  width: 0;
  height: 0;
  border-width: 12px;
  border-color: rgb(0, 0, 0) transparent transparent transparent;
  border-style: dashed solid dashed dashed;
}
</style>